module.exports = __webpack_public_path__ + "img/systemAllFlow.4c0a159b.jpg";